import { Play, Info } from 'lucide-react';

export const NetflixHero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="netflix-hero relative">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5fGVufDB8fHx8MTc2MDMyNTYzNXww&ixlib=rb-4.1.0&q=85"
          alt="Technology Risk Leadership"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="netflix-hero-content">
        {/* Status Badge */}
        <div className="mb-4">
          <span className="inline-block bg-netflix-red text-white px-3 py-1 rounded text-sm font-semibold">
            Available for Strategic Leadership Roles
          </span>
        </div>

        {/* Title */}
        <h1 className="netflix-title text-white">
          Strategic Technology
          <br />
          Risk Leader
        </h1>

        {/* Description */}
        <p className="netflix-description text-white">
          15+ years transforming enterprise technology risk through innovative governance frameworks, 
          regulatory compliance, and AI safety controls at Google, LinkedIn, and Fortune 500 companies. 
          Expert in IT risk domains including data security, system availability, processing integrity, and confidentiality controls.
        </p>

        {/* Netflix Style Buttons */}
        <div className="flex items-center space-x-4">
          <button 
            className="netflix-btn-play flex items-center space-x-2"
            onClick={() => scrollToSection('#experience')}
          >
            <Play className="w-5 h-5 fill-current" />
            <span>View Experience</span>
          </button>
          <button 
            className="netflix-btn-info flex items-center space-x-2"
            onClick={() => scrollToSection('#contact')}
          >
            <Info className="w-5 h-5" />
            <span>More Info</span>
          </button>
        </div>

        {/* Key Stats */}
        <div className="flex items-center space-x-8 mt-8">
          <div className="text-center">
            <div className="text-2xl font-bold text-netflix-red">15+</div>
            <div className="text-sm text-netflix-gray-400">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-netflix-red">8</div>
            <div className="text-sm text-netflix-gray-400">Certifications</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-netflix-red">4</div>
            <div className="text-sm text-netflix-gray-400">Publications</div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-netflix-red">$125M</div>
            <div className="text-sm text-netflix-gray-400">Risk Capital</div>
          </div>
        </div>
      </div>
    </div>
  );
};